// How to get notifications on an iPhone or iPad: add the site to the Home Screen.
//
// iOS only allows web push for a site that has been ADDED TO THE HOME SCREEN and
// opened from that icon (iOS 16.4 and later). In an ordinary Safari tab there is
// no PushManager at all, so the usual "Turn on push" button cannot exist, and
// without this help the page would just say push is unsupported. Found 2026-10-20
// when an iPhone "worked" in every other respect and never asked for permission.
// The site also needs a real web app manifest for the icon to install as an app
// (web/public/manifest.webmanifest); without one iOS makes a plain bookmark.
//
// Native shells never see this: the Capacitor app has its own (future) push path.

import { el } from '../dom.js';
import { isNative } from '../platform.js';

/** An iPhone or iPad looking at the site in a Safari tab rather than the installed app. */
export function isIosBrowserTab(): boolean {
  if (isNative()) return false;
  const ua = navigator.userAgent;
  // iPadOS reports itself as a Mac, so touch support is what tells them apart.
  const ios =
    /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!ios) return false;
  const standalone =
    (navigator as unknown as { standalone?: boolean }).standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches;
  return !standalone;
}

/** The steps, as a small block that fits both onboarding and the settings card. */
export function iosInstallHelp(): HTMLElement {
  return el('div', { class: 'ios-install-help' }, [
    el(
      'p',
      {},
      'To get notifications on your iPhone or iPad, add MySocialCal to your Home Screen first:',
    ),
    el('ol', {}, [
      el('li', {}, 'Open mysocialcal.com in Safari (not another browser).'),
      el('li', {}, 'Tap the Share button (the square with an arrow), then Add to Home Screen, then Add.'),
      el('li', {}, 'Open MySocialCal from the new Home Screen icon and sign in.'),
      el('li', {}, 'Go to Notification settings and tap Turn on for this device.'),
    ]),
    el('p', { class: 'muted small' }, 'Needs iOS 16.4 or newer.'),
  ]);
}
